import Axios from 'axios';
import QS from 'qs';
import csConfig from './csConfig';

const template = (traceId = '', startTime = 0, endTime = 0, tags = {}) => {
  const domain = window.location.host || '';
  const { localAppName, localClusterName, remoteAppName, remoteClusterName } = csConfig(domain);
  return {
    annotations: [
      {
        timestamp: startTime,
        value: 'cs',
      },
      {
        timestamp: endTime,
        value: 'cr',
      },
    ],
    duration: +endTime - +startTime,
    id: '0',
    kind: 'CLIENT',
    localEndpoint: {
      ipv4: '',
      port: -1,
      appName: localAppName,
      clusterName: localClusterName,
    },
    remoteEndpoint: {
      ipv4: '',
      port: -1,
      appName: remoteAppName,
      clusterName: remoteClusterName,
    },
    sampled: true,
    tags,
    timestamp: startTime,
    traceId,
    root: true,
    type: 'HTML',
  };
};

class WholeLink {
  constructor() {
    this.traceId = '';
    this.startTime = 0;
    this.endTime = 0;
    this.tags = {};
  }

  setTraceId(traceId) {
    this.traceId = traceId;
  }

  setStartTime(startTime) {
    this.startTime = startTime;
  }

  setEndTime(endTime) {
    this.endTime = endTime;
  }

  setTags = (req, res) => {
    const { headers, url = '', method = 'get', params = {}, data = {} } = req;
    const { protocol, host } = window.location;
    const paramsStr = QS.stringify(params) ? `?${QS.stringify(params)}` : '';
    let httpUrl = url.match(/^\/\//)
      ? `${protocol}${url}${paramsStr}`
      : `${protocol}//${host}/wemedia${url}${paramsStr}`;
    if (url.match(/^https?:/)) httpUrl = url;
    let domain = '';
    if (url.match(/(^\/\/)|(^https?:)/) && url.split('//')[1] && url.split('//')[1].split('/')[0]) {
      domain = url.split('//')[1].split('/')[0];
    } else {
      domain = host;
    }
    const tags = {
      serviceType: 'mp',
      contentLength: null,
      domain,
      headers,
      httpUrl,
      method,
      requestBody: data,
      netType: null,
      userAgent: window.navigator.userAgent,
      userId: params.wemediaId || null,
      protocol: 'HTTP/1.1',
    };

    if (res instanceof Error) {
      const response = res.response || {};
      Object.assign(tags, {
        responseCode: response.status,
        responseHeaders: response.headers,
        resultData: null,
        exceptionMsg: res.message,
        businessCode: null,
      });
    } else {
      const resData = res.data || {};
      Object.assign(tags, {
        responseCode: res.status,
        responseHeaders: res.headers,
        exceptionMsg: res.msg || null,
        businessCode: resData.code,
        resultData: resData,
      });
    }
    this.tags = { ...tags };
  };

  sendData() {
    const data = template(this.traceId, this.startTime, this.endTime, this.tags);
    Axios.post('//collect.ws.126.net/collector/api/collect/html', [data])
      .then(() => {})
      .catch(() => {});
  }
}

export default WholeLink;
